import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../redux/snackbar';

export default function Success() {
  const dispatch = useDispatch();

  return () => {
    dispatch(
      setSnackbar(
        true,
        'success',
        'Ação Submetida com Sucesso!',
      ),
    );
  };
}
